// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://stgsp1.appsndevs.com/bidjones/api/v1/', /before mar-2022/
  // apiUrl:'https://stgphys.appsndevs.com/bidjones/api/v1/', /staging server link given by@Villiam Sir/
  apiUrl: "https://bidjones.com/bidjones/api/v1/" /*live server URL*/,
  // apiUrl: "https://stgps.appsndevs.com/bidjones/api/v1/",
  // apiUrl: "http://stgsp1.appsndevs.com/bidjones/admin" /*Staging server URL*/,
  sandBoxUrll: "https://api-m.sandbox.paypal.com/" /*sandBox Url*/,
  //bidjonesUrl: "http://localhost:4200/" /*local server URL*/,

  bidjonesUrl: "https://bidjones.com/" /*live server URL*/,
  apiUrll: "http://localhost:4200/" /*local Url*/,
  accessKeyId: "AKIAJJNDTANX7JZ5NFPA",
  secretAccessKey: "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",
  region: "us-west-2",
  s3Bucket: "bidjonesbucketprivate",
  paypalBaseSandBoxUrl: "https://api-m.sandbox.paypal.com/",
  baseUrl: "https://web-application-8ca8d.firebaseapp.com",
  pusher: {
    key: "0d7ec5c1d19bfe8a50cb",
    cluster: "ap2",
  },
  stripeurl:
    "https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=ca_EhG8I0NY8m90bn6cdKPnOJGR7L5VTvQ1&scope=read_write&state=",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts